




import { defineComponent, ref } from "@vue/composition-api";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useFilter from "@/hooks/useFilter";
import providers from "@/lib/api";
import { getLoginData } from "@/lib/authHelper";
import AppointmentsView from "./components/AppointmentsView";
import { appointmentsTabs } from "./config";

export default defineComponent({
  name: "PageAppointments",
  components: { AppointmentsView },
  props: {
    tab: { type: String },
  },
  setup(_, { root }) {
    const { authUserStrict, authorities } = useAuthUser();
    const loading = ref(true);
    const checkSettings = async () => {
      if (!checkAuthorities(authorities.value, ["updateMyAppointmentType"])) {
        loading.value = false;
        return;
      }
      let hasAppointments = false;
      let hasAppointmentTypes = false;
      let hasAppointmentAvailability = false;
      await Promise.all([
        providers.AppointmentProvider.search({
          providerId: authUserStrict.value.id,
          size: 1,
          includeHidden: true,
        }).then(r => (hasAppointments = r.totalRecords > 0)),
        providers.AppointmentTypeProvider.search({
          data: { userIds: [authUserStrict.value.id] },
        }).then(
          r => (hasAppointmentTypes = (r.find(i => i.userId === authUserStrict.value.id)?.types ?? []).length > 0)
        ),
        providers.UserAvailabilityProvider.search({
          data: { userIds: [authUserStrict.value.id] },
        }).then(
          r =>
            (hasAppointmentAvailability =
              (r.find(i => i.userId === authUserStrict.value.id)?.intervals ?? []).length > 0)
        ),
      ]);
      if (!(hasAppointments || hasAppointmentTypes || hasAppointmentAvailability))
        root.$router.replace({ name: "appointmentsSettings", query: { onboarding: "true" } });
      else loading.value = false;
    };
    checkSettings();
    return {
      loading,
    };
  },
  beforeRouteEnter(to, from, next) {
    const { filterMap } = useFilter();
    const loginData = getLoginData();
    const filteredTabs = filterMap(appointmentsTabs, loginData?.user ?? null, loginData?.authorities ?? []);
    const tabName = to.query.tab ? (typeof to.query.tab === "string" ? to.query.tab : to.query.tab[0]) : "";
    tabName && !!filteredTabs[tabName] ? next() : next(filteredTabs[Object.keys(filteredTabs)[0]].to);
  },
});
